import { IPart, IPartCategory } from "../../../models/Part";
import PriceFormat from '../../../utils/priceFormat';
import { LockClosedIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import classNames from "../../../utils/classNames";
import { PartProBlackList } from "../../../models/PartLookup";

interface PartProPriceButtonProps {
  category?: IPartCategory;
  part?: IPart;
  onPriceSelect: (price: number) => void;
  partProUnlocked: boolean;
  partProLoading: boolean;
  onLockedClick?: () => void;
}

export default function PartProPriceButton({ category, part, onPriceSelect, partProUnlocked, partProLoading, onLockedClick }: PartProPriceButtonProps) {
  const { t } = useTranslation("common");

  if (PartProBlackList.includes(part?.vehicle?.combinedMake?.toLowerCase() ?? "")) return null;

  const noUcid = !(
    (category?.ucid ?? part?.category?.ucid)?.trim()
  );

  if (noUcid) return null;

  const proPrice = parseFloat(((category?.lookupAveragePrice ? category.lookupAveragePrice : part?.suggestedPrice) ?? 0).toFixed(2));

  if (!partProUnlocked) {
    return (
      <button
        title={t("Activate Part Pro")}
        disabled={partProLoading}
        onClick={partProLoading ? undefined : onLockedClick}
        className={classNames(partProLoading && "animate-pulse", "border text-white shadow rounded-md p-1 px-2 bg-wilma-500 text-allowed cursor-pointer w-20")}
        type="button"
      >
        <span className="font-bold flex justify-center"><LockClosedIcon height={15} width={15} /></span>
      </button>
    );
  }

  return (
    <button
      title={t("Part Pro Price")}
      onClick={() => onPriceSelect(proPrice)}
      className="border text-white shadow rounded-md p-1 px-2 bg-wilma-500 hover:bg-wilma-400 w-20 text-center"
      type="button"
    >
      <span className="font-bold">{PriceFormat(proPrice)}</span>
    </button>
  );
} 